module.exports = __webpack_public_path__ + "static/media/logo.d9797231.png";


//////////////////
// WEBPACK FOOTER
// ./src/Img/logo.png
// module id = 1021
// module chunks = 0